export const ITEM_TYPE = {
  link: 'link',
  menu: 'menu',
  collapse: 'collapse',
  header: 'header',
  brandVoice: 'brandVoice',
  visualLanguage: 'visualLanguage',
};

export const SIDEBAR_ACTION = {
  createBrandVoice: 'createBrandVoice',
  editBrandVoice: 'editBrandVoice',
  deleteBrandVoice: 'deleteBrandVoice',

  createVisualLanguage: 'createVisualLanguage',
  editVisualLanguage: 'editVisualLanguage',
  deleteVisualLanguage: 'deleteVisualLanguage',
};
